export default {"src":"/_next/static/media/CT_LOGO.3f3e2ea3.svg","height":17,"width":99,"blurWidth":0,"blurHeight":0};